import React from 'react'
const SvgArrow1 = props => (
  <svg viewBox='0 0 24 44.84' {...props}>
    <defs>
      <style>{'.arrow_1_svg__cls-1{fill:#fd5c1f}'}</style>
    </defs>
    <g id='arrow_1_svg__\u56FE\u5C42_2' data-name='\u56FE\u5C42 2'>
      <g id='arrow_1_svg__\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
        <path className='arrow_1_svg__cls-1' d='M12 0v30M10 0h4v30h-4z' />
        <path className='arrow_1_svg__cls-1' d='M24 28.84l-12 16-12-16' />
      </g>
    </g>
  </svg>
)
export default SvgArrow1
